// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-features-OverseasPremium-DetailModal-style__content--buymk{width:432px;box-sizing:border-box;padding:16px 16px 24px}.src-features-OverseasPremium-DetailModal-style__content--buymk .src-features-OverseasPremium-DetailModal-style__bold--YxVvO{font-weight:bold}`, "",{"version":3,"sources":["webpack://./src/features/OverseasPremium/DetailModal/style.scss"],"names":[],"mappings":"AACA,gEACE,WAAA,CACA,qBAAA,CACA,sBAAA,CAEA,6HACE,gBAAA","sourcesContent":["@use 'src/utils/css/variables' as *;\n.content {\n  width: 432px;\n  box-sizing: border-box;\n  padding: 16px 16px 24px;\n\n  .bold {\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lHeaderHeight": `56px`,
	"lCompanyHeight": `114px`,
	"h2FontSize": `28px`,
	"h3FontSize": `20px`,
	"bodyLineHeight": `20px`,
	"lGnShrinkWindowWidth": `1591px`,
	"tableVerticalPadding": `8px`,
	"tableHorizontalPadding": `16px`,
	"lPersonnelBreakWidth": `1599px`,
	"cNavigationAccent": `#f57f17`,
	"cTableBodyOdd": `#fff`,
	"cTableBodyEven": `#f2f6f8`,
	"cTableHover": `#c5ddeb`,
	"cTableHeadOdd": `#eaf1f5`,
	"cTableHeadEven": `#dee8ef`,
	"zPageLoading": `2`,
	"content": `src-features-OverseasPremium-DetailModal-style__content--buymk`,
	"bold": `src-features-OverseasPremium-DetailModal-style__bold--YxVvO`
};
export default ___CSS_LOADER_EXPORT___;
